var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"videoPlayer",staticClass:"video-js vjs-big-play-centered",attrs:{"id":"vimeo-video","autoplay":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }